import axios from 'axios';

// Use a relative URL as fallback so it works in any environment
// Ensure the API URL is trimmed to avoid issues with trailing spaces
const API_URL = (import.meta.env.VITE_API_URL || '/api').trim();

/**
 * Generates a session ID via the backend API
 */
export const generateSessionId = async (): Promise<string> => {
  try {
    const response = await axios.get(`${API_URL}/api/chat/session`);
    
    if (response.data.success && response.data.sessionId) {
      return response.data.sessionId;
    }
    
    // Fallback to local generation if API fails
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  } catch (error) {
    console.error('Error generating session ID via API:', error);
    // Fallback to local generation
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
}; 